// @flow

import { connect } from 'react-redux';

import tagsReducer from '@app/reducers/entities/tags';

import TagComponent from './tag';

export const mapStateToProps = (state, ownProps) => {
  const tag = tagsReducer.getTagSelector(state, { id: ownProps.match.params.id });

  return {
    tag,
    fetchState: tagsReducer.getFetchSelector(state, { id: ownProps.match.params.id }),
  };
};

export const mapDispatchToProps = (dispatch, { match }) => ({
  fetchTag: () => {
    dispatch(tagsReducer.fetchTag({ id: match.params.id }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TagComponent);
